<script setup lang="ts">
import DropdownMenuItemContent from "~/components/dumb/DropdownMenuItemContent.vue";
import Template from "~/components/dumb/Template.vue";
import Tooltip from "~/components/dumb/Tooltip.vue";
import { Placement } from "~/shared/enums";
import type { ProcessedMenuItem } from "~/shared/types";
import { usePageStore } from "~/stores";

const props = defineProps<{
  item: ProcessedMenuItem;
  highlightOnly?: boolean;
  grid?: boolean;
  emoji?: boolean;
}>();

const emit = defineEmits<{
  click: [event: Event];
}>();

const pageStore = usePageStore();

const onClick = (event: Event) => {
  if (!props.item.disabled && !props.item.noFocus) {
    emit("click", event);
  }
};
</script>

<template>
  <component
    :is="item.disabled && item.disabledReason ? Tooltip : Template"
    :placement="Placement.LEFT"
    :text="item.disabledReason"
    block
    :show-delay="200">
    <div v-if="item.disabled && !pageStore.isMobile" class="absolute inset-0" />
    <component
      :is="item.component"
      v-bind="item.args"
      :class="{
        'pointer-events-none text-vlt': item.disabled,
        'text-md': !item.disabled,
        'cursor-pointer': !item.disabled && !item.noFocus,
        'hover:bg-md': !item.disabled && !item.noFocus && !highlightOnly,
        'h-full': grid,
        'py-1.5 text-base': pageStore.isMobile,
        'text-sm': !pageStore.isMobile,
      }"
      class="group/strokes flex w-full select-none"
      @click="onClick">
      <DropdownMenuItemContent
        :title="item.title"
        :icon="item.icon"
        :icon-args="item.iconArgs"
        :selected="item.selected"
        :disabled="item.disabled"
        :subtitle="item.subtitle"
        :subtitle-copy-description="item.subtitleCopyDescription"
        :strikethrough="item.strikethrough"
        :command-id="item.commandId"
       
        :grid="grid"
        :emoji="emoji" />
    </component>
  </component>
</template>
